module.exports = __webpack_public_path__ + "static/media/badminton.ec68ad44.png";